import Controller, { OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { Inject } from '@odinjs/odin';

import BaseController from '../../BaseController';
import { FragmentNames, LocatorMaterialMedicineClassAliases } from '../../../codegen';
import { DeckAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import '../locator.css';

@Controller({ component: LocatorMaterialMedicineClassAliases.LAYOUT_LOCATOR, fragment: FragmentNames.LOCATOR_MATERIAL_MEDICINE_CLASS })
export default class LocatorActiveIngredientController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(LocatorMaterialMedicineClassAliases.DECK_LOCATOR)
    deckLocatorAPI!: DeckAPI;

  @Inject(LocatorMaterialMedicineClassAliases.FILTER_LOCATOR)
    filterLocatorApi!: FilterAPI;

  @OnClick({ target: LocatorMaterialMedicineClassAliases.BUTTON_SELECT_LOCATOR })
  onSelectButtonClick(): void {

    const submitableEvent = {
      record: this.deckLocatorAPI.getSelectedCards()[0]
    };

    if (submitableEvent.record) {
      this.submittableFragmentContext.submit(new SubmitEvent(submitableEvent));
    }
  }

  @OnMount({ target: LocatorMaterialMedicineClassAliases.LAYOUT_LOCATOR })
  onMountLayout(): void {
    this.filterLocatorApi.restoreState(true);
  }

  @OnUnmount({ target: LocatorMaterialMedicineClassAliases.FILTER_LOCATOR })
  onFilterUnmount(event: MountEvent): void {
    const filterLocator = event.target as FilterAPI;
    filterLocator.persistState();
  }
}
